<template>
  <div>
    <template v-if="filteredList.length">
      <paginate
        v-if="filteredList.length"
        ref="paginator"
        name="announcementsPaginate"
        :list="filteredList"
        :per="6"
        :refreshCurrentPage="true"
      >
        <div class="item" v-for="(item,i ) in paginated('announcementsPaginate')" :key="i">
          <div class="item-date">
            <div class="date-circle">
              <div class="day">{{ new Date(item.date).getDate() }}</div>
              <div class="month">{{ new Date(item.date).getMonth()+1 | month(lng) }}</div>
              <div class="year">{{ new Date(item.date).getFullYear() }}</div>
            </div>
          </div>
          <div class="item-text">
            <h1 class="title">{{ item.key }}</h1>
            <div class="text" v-html="crop(item.body,140)"></div>
            <router-link :to="fixLink(item.id)" class="link-to">Detay için tıklayın...</router-link>
          </div>
        </div>
      </paginate>
      <paginate-links
        v-if="filteredList.length"
        for="announcementsPaginate"
        :hide-single-page="true"
        :limit="3"
        :show-step-links="true"
      ></paginate-links>
    </template>
    <p class="notfound" v-else>{{ t.announcement.notFound }}</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      paginate: ["announcementsPaginate"]
    };
  },
  computed: {
    ...mapGetters(["lng", "t", "announcements"]),
    // dynamic list
    filteredList() {
      const params = this.$route.params.year;
      const type = this.$route.params.type;
      const current = new Date();
      // filter for type and validityenddate
      const filtered = this.announcements
        .filter(item => {
          if (
            !params ||
            (params == current.getFullYear() && type !== "archive")
          ) {
            return (
              // start_Date < current < end_date
              (new Date(item.date) <= current &&
                new Date(item.announcement_validityenddate) > current) ||
              // start_Date < current
              // end_Date = 'undefined'
              (new Date(item.date) <= current &&
                item.announcement_validityenddate == null) ||
              // start_Date = 'undefined'
              // end_Date = 'undefined'
              (item.date == null && item.announcement_validityenddate == null)
            );
          }
          return (
            new Date(item.date).getFullYear() == this.$route.params.year &&
            (item.announcement_validityenddate == null ||
              new Date(item.announcement_validityenddate) < current)
          );
        })
        .sort((a, b) => {
          return new Date(a.date) - new Date(b.date);
        })
        .reverse();
      //  Return
      return filtered;
    }
  },
  methods: {
    // summary info text
    crop(value, limit) {
      const val = value ? value : "";
      const txt = document.createElement("textarea");
      txt.innerHTML = val.replace(/(<([^>]+)>)/gi, "");
      return txt.value.length > 140
        ? txt.value.substr(0, limit) + " ..."
        : txt.value;
    },
    // router fixed
    fixLink(id) {
      return (
        (this.$route.params.year
          ? this.$route.params.year
          : this.$route.params.type + "/" + new Date().getFullYear()) +
        "/" +
        id
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/colors";
@import "../../styles/announcements_partner";
</style>
